import { IPositionData } from "./position-data";

export interface IBackgroundData {
    mediaBackground?: IMediaBackgroundData | null;
    style?: IBackgroundStyle | null;
}

export type IMediaBackgroundData = IImageBackgroundData | IVideoBackgroundData;

export interface IImageBackgroundData {
    readonly type: "image";
    src?: string | null;
    style?: IMediaBackgroundStyle | null;
    altText?: string;
}

export interface IVideoBackgroundData {
    readonly type: "video";
    src?: string | null;
    thumbnailUrl?: string | null;
    style?: IMediaBackgroundStyle | null;
}

export interface IMediaBackgroundStyle {
    opacity?: number | null;
    position?: IPositionData | null;
}

export interface IBackgroundStyle {
    color?: string | null;
}

export abstract class BackgroundData {

    public static get defaultStyle(): IBackgroundStyle {
        return {
            color: `rgba(255, 255, 255, 1)`
        };
    }

    public static get defaultData(): IBackgroundData {
        return {
            style: this.defaultStyle
        };
    }

    public static get defaultContentData(): IBackgroundData {
        return {
            style: {
                color: `rgba(255, 255, 255, 0)`
            }
        };
    }

    public static get defaultHeaderData(): IBackgroundData {
        return {
            style: {
                color: `rgba(255, 255, 255, 1)`
            }
        };
    }

}
